export default (state = {
	counter: 0
}, { type }) => {
	switch (type) {

		case 'SET_AUTHORIZE_COUNTER':
			return {
				counter: state.counter + 1
			}

		default:
			return state
	}
}
